import React, { useEffect, useRef } from "react";
import { cn } from "@/lib/utils";
import gsap from "gsap";

const NavLinks = ({ links, isMobile = false, extraRefs = [], onLinkClick }) => {
  const linksRef = useRef([]);
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (hasAnimated.current) return;

    const elementsToAnimate = [
      ...linksRef.current.filter(Boolean),
      ...extraRefs.map((ref) => ref.current).filter(Boolean),
    ];

    if (!elementsToAnimate.length) return;

    const ctx = gsap.context(() => {
      gsap.from(elementsToAnimate, {
        y: -20,
        autoAlpha: 0, // handles opacity + visibility
        duration: 0.6,
        stagger: 0.15,
        ease: "power3.out",
        onComplete: () => {
          hasAnimated.current = true;
        }
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <>
      {links.map(({ href, label }, index) => (
        <a
          key={label}
          href={href}
          ref={(el) => (linksRef.current[index] = el)}
          onClick={onLinkClick}
          className={cn(
            "px-3 py-2 font-medium transition-colors",
            isMobile
              ? "block text-base text-gray-900 hover:text-blue-600"
              : "text-sm text-gray-900 hover:text-blue-600"
          )}
        >
          {label}
        </a>
      ))}
    </>
  );
};

export default NavLinks;
